import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { ReferralCodeStore } from './typings';

const initialState: ReferralCodeStore = {
    loadingStatus: LOADING_STATUSES.UNSENT,
    referralCode: '',
};

const slice = createSlice({
    name: 'REFERRAL_CODE',
    initialState: initialState,
    reducers: {
        loadReferralCode: (state: ReferralCodeStore) => {
            state.loadingStatus = LOADING_STATUSES.LOADING;
        },
        loadReferralCodeSuccess: (state: ReferralCodeStore, action: PayloadAction<string>) => {
            state.loadingStatus = LOADING_STATUSES.SUCCESS;
            state.referralCode = action.payload;
        },
    },
});

export const actions = slice.actions;
export const referralCodeReducer = slice.reducer;
